import { UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';

import { ExtendedRoute } from '@hdms/shared/common-types';

/**
 * Checks the given URL segments for the given feature base route via RegEx and
 * consumes this part of the url. Also consuming only the part up until and including
 * the given feature base route to allow routing within the feature itself.
 *
 * @param segments The url segments as given by the router.
 * @param group The url segment group as given by the router.
 * @param route The route as given by the router.
 *
 */
export function regexBaseRouteMatcher(
  segments: UrlSegment[],
  group: UrlSegmentGroup,
  route: ExtendedRoute
): UrlMatchResult {
  const { path } = route.data || {};
  if (!path) {
    throw new Error('"path" MUST be defined in route data');
  }
  // Catch there not being a urlSegment at all
  if (segments[0]) {
    const pathRegex = new RegExp(path);
    // Loop the urlSegments
    for (let idx = 0, len = segments.length; idx < len; idx++) {
      // In case the current urlSegment is the feature base route.
      if (pathRegex.test(segments[idx].path)) {
        // Consume the urlSegments until and including the feature base route.
        // idx + 1 because second parameter of Array.slice is exclusive.
        return { consumed: segments.slice(0, idx + 1) };
      }
    }
  }
  return null;
}
